// import moment from "moment";
import React from "react";
import moment from "moment-timezone";
import DOMPurify from "dompurify";
import { addSessions, updateTracks } from "../revampCRUD/agenda.crud";
import GetCurrency from "../revampComponents/Atom/services/GetCurrency";
import { getAllMultiCheckins } from "../revampCRUD/multiCheckIn.crud";
import { retrieveTicketRegeneration } from "../revampCRUD/regenerateTickets.crud";
import { successToaster, errorToaster } from "../reusable/common";
import { currencyLocaleMap, downloadAttendeesCheckboxesSection, threeDecimalCurrencies, zeroDecimalCurrencies } from "./constants";
import { api } from "../revampCRUD/axios.config";
import { toast } from "react-toastify";
import { recaptchaId } from "../config/config";
import axios from "../revampCRUD/axios";

// this function gives you the event base URL
export const getBaseURL = () => {
	let newHostName = "";
	if (window.location.hostname == "events.konfhub.com") {
		newHostName = "https://konfhub.com/";
	} else {
		newHostName = "https://dev.konfhub.com/";
	}

	return newHostName;
};

// Returns date and time from IST to utc
export const getUTCDateNTime = (dateTime, timezone) => {
	const tempDateTime = moment.tz(dateTime, timezone).format();

	let tempData;
	tempData = new Date(tempDateTime).toISOString();
	tempData = tempData.toString();
	tempData = tempData.slice(0, tempData.length - 5);
	tempData = tempData.replaceAll("T", " ");

	return tempData;
};

// consistent timezone-based formatting and comparisons across the app.
export const getMomentInTimeZone = (localDateTime, timeZone) => {
	return moment.tz(localDateTime, timeZone)
}
// Returns date and time from utc to IST
export const getISTDateNTime = (dateTime, timezone, optional = false, format = false) => {
	let convertedDateTime;
	convertedDateTime = moment.utc(dateTime).tz(timezone);



	if (optional === "needed") {
		const addGmtOrNot = moment.tz(timezone).zoneAbbr().includes("+")
			? `GMT${moment.tz(timezone).zoneAbbr()}`
			: moment.tz(timezone).zoneAbbr();
		const date = moment(convertedDateTime).format("MMM DD, YYYY hh:mm A ") + addGmtOrNot;

		return date;
	} else if (optional == "timezoneDate") {
		const date =
			moment(convertedDateTime).format("YYYY-MM-DD HH:mm:ss ") +
			moment.tz(timezone).format("z");
		return date;
	} else if (optional == "timezoneNTime") {
		const date = moment(convertedDateTime).format("HH:mm A ") + moment.tz(timezone).format("z");
		return date;
	} else if (optional == "timezoneNDate") {
		const date =
			moment(convertedDateTime).format("DD MMM YY, ") + moment.tz(timezone).format("z");
		return date;
	} else if (optional == "Date") {
		const date = moment(convertedDateTime).format("DD MMM YY");
		return date;
	} else if (optional == "needed") return moment(convertedDateTime).format("YYYY-MM-DD HH:mm");
	else if (optional == "ticket")
		return moment(convertedDateTime).format("YYYY-MM-DD HH:mm").replace(/ /g, "T");
	else if (optional == "time") {
		const date = moment(convertedDateTime).format("hh:mm A ");
		return date;
	} else if (optional == "forTime") {
		return convertedDateTime;
	} else if (optional == "bulkUpload") {
		return moment(convertedDateTime).format("lll");
	} else if (format) {
		const date = moment(convertedDateTime).format(format);
		return date;
	} else return moment(convertedDateTime).format("YYYY-MM-DD HH:mm:ss");

	// return date;
};

export const getCurrentDate = eventId => {
	const tempCurrentDate = getISTDateNTime(new Date(), eventId);
	let timeOffset = moment.tz(eventId).format("Z");
	const offsetSign = timeOffset.slice(0, 1);
	timeOffset = timeOffset.slice(1);
	var timeParts = timeOffset.split(":");
	const timeOffsetValue = Number(timeParts[0]) * 60 + Number(timeParts[1]);
	const timeData = {
		today_from_timestamp: tempCurrentDate.slice(0, 10) + "T00:00:00",
		today_to_timestamp: tempCurrentDate.slice(0, 10) + "T23:59:59",
		time_offset: offsetSign.concat(timeOffsetValue).replace("+", "")
	};
	return timeData;
};

//Get time from date and time
export const getTimeInRequiredTimeZone = (dateTime, timezone) => {
	const utcDate = new Date(dateTime + 'Z'); // Append 'Z' to indicate UTC

	//This function converts time zone to standard time. ex: Asia/Calcutta to IST, Asia/Dubai to GMT+04
	const conversionOfTimeZoneToStandardTime = moment
		.tz(timezone)
		.format("z")
		.includes("+")
		? `GMT${moment.tz(timezone).format("z")}`
		: `${moment.tz(timezone).format("z")}`

	const options = {
		hour: '2-digit',
		minute: '2-digit',
		hour12: true,
		timeZone: timezone,
	};

	// Format the date
	const formattedTime = new Intl.DateTimeFormat('en-US', options).format(utcDate);

	return `${formattedTime} ${conversionOfTimeZoneToStandardTime}`;
}

//Initial value to return date format for safari and other browsers
export const convertToDateObj = value => {
	if (value) return moment(value).toDate();
	return null;
};

//Capital letter of every words
export const capitalizeFirst = str => {
	return str.charAt(0).toUpperCase() + str.slice(1);
};

// Replace placeholder variables - dropdown in editors
export const replacePlaceholder = async (tempDataParam, eventDetails) => {
	const ISTStartDateAndStartTime = getISTDateNTime(
		eventDetails?.start_date + " " + eventDetails?.start_time,
		eventDetails?.time_zone,
		eventDetails?.start_date + " " + eventDetails?.start_time,
		eventDetails?.time_zone
	);

	const ISTEndDateAndEndTime = getISTDateNTime(
		eventDetails?.end_date + " " + eventDetails?.end_time,
		eventDetails?.time_zone,
		eventDetails?.end_date + " " + eventDetails?.end_time,
		eventDetails?.time_zone
	);
	let tempData = tempDataParam;
	tempData = tempData?.replaceAll("$event_name", eventDetails.name);
	tempData = tempData?.replaceAll("$event_venue", eventDetails.venue);
	tempData = tempData?.replaceAll("$event_city", eventDetails.city);
	tempData = tempData?.replaceAll("$event_state", eventDetails.state);
	tempData = tempData?.replaceAll("$event_country", eventDetails.country);

	tempData = tempData?.replaceAll("${event_start_time}", ISTStartDateAndStartTime.split(" ")[1]);
	tempData = tempData?.replaceAll("${event_end_time}", ISTEndDateAndEndTime.split(" ")[1]);
	tempData = tempData?.replaceAll("${event_start_date}", ISTStartDateAndStartTime.split(" ")[0]);
	tempData = tempData?.replaceAll("${event_end_date}", ISTEndDateAndEndTime.split(" ")[0]);

	tempData = tempData?.replaceAll("$event_website", eventDetails.event_website);
	tempData = tempData?.replaceAll("$event_live_link", eventDetails.event_live_link);
	tempData = tempData?.replaceAll("$organiser_email", eventDetails.organiser_email);
	tempData = tempData?.replaceAll("$event_url", `${getBaseURL()}${eventDetails.event_url}`);
	// extra space gett?ing added - removing it
	tempData = tempData?.replaceAll("<p>", `<p style="margin:0px 0px">`);
	tempData = tempData?.replaceAll("<li>", `<li style="white-space:initial">`);
	return tempData;
};

export const getCurrentEventId = () => {
	const pathname = window.location.pathname;
	const eventId = pathname.split("/")[2];
	return eventId;
};

// App.js
export const sortEventDetails = eventDetails => {
	var sortedEventDetails = [];
	if (eventDetails !== undefined && eventDetails.length > 0) {
		eventDetails.forEach(event => {
			if (event.event_status) {
				sortedEventDetails.push(event);
			}
		});

		eventDetails.forEach(event => {
			if (!event.event_status) {
				sortedEventDetails.push(event);
			}
		});
	} else {
		return eventDetails;
	}

	return sortedEventDetails;
};

//Scroll up to the form which has error
export const scrollToError = (formik, errorId = false) => {
	const err = Object.keys(formik.errors);
	if (err.length) {
		let input;
		if (errorId) {
			input = document.getElementById(errorId);
		} else {
			input = document.querySelector(`input[name='${err[0]}']`);
		}

		input?.scrollIntoView({
			behavior: "smooth",
			block: "nearest",
			inline: "center"
			// inline: 'start',
		});
	}
};

/*************************************************** AGENDA **************************************/
//This function returns an array which contains all the dates in between the start and end dates you provide including them
export const getDaysArray = function (start, end) {
	const startDate = moment(start);
	const endDate = moment(end);
	const days = [];

	while (startDate.isSameOrBefore(endDate, 'day')) {
		days.push(startDate.format("YYYY-MM-DD"));
		startDate.add(1, 'day');
	}

	return days;
};

export const getTimesArray = (
	startTimeString,
	endTimeString,
	timDiff = 15,
	removeSuffix = false,
	date = "2023-02-22"
) => {
	const startTime = new Date(`${date} ${startTimeString}`);
	const endTime = new Date(`${date} ${endTimeString}`);
	const timeArray = [];
	while (startTime <= endTime) {
		const timeString = startTime.toLocaleTimeString([], {
			hour: "2-digit",
			minute: "2-digit"
		});
		timeArray.push(removeSuffix ? `${timeString.split(" ")[0]}:00` : timeString);
		startTime.setMinutes(startTime.getMinutes() + timDiff);
	}
	return timeArray;
};

export const convertToDropElement = (session, isFromTrack = false) => {
	if (isFromTrack) {
		const charCount = session.session_title.length;
		const height = parseInt(charCount / 27) + 1; //27 characters fit in one line
		return {
			i: `${session.session_id}`,
			w: 1,
			h: !_.isEmpty(session.session_speakers) ? 2 + height : 1 + height
		};
	} else if (!isFromTrack) {
		// let timeArray = getTimesArray(session.start_timestamp.split(" ")[1], session.end_timestamp.split(" ")[1]);
		// let height = timeArray.length - 1;
		// let sessionId = session.session_id
		// return {i: `${sessionId}`, h: height, w: 1}
		const sessionId = session.session_id;
		return { i: `${sessionId}`, h: 2, w: 1 };
	}
};

function markDuplicateObjects(...arrays) {
	const objectCount = {};

	// Loop through the objects in each array and count the number of times each object appears
	for (let i = 0; i < arrays.length - 1; i++) {
		const arr = arrays[i];
		const nextArr = arrays[i + 1];

		for (const obj of arr) {
			const objString = JSON.stringify(obj);

			if (nextArr.some(nextObj => JSON.stringify(nextObj) === objString)) {
				if (objString in objectCount) {
					objectCount[objString]++;
				} else {
					objectCount[objString] = 1;
				}
			}
		}
	}

	// Loop through the objects in each array and add a `duplicate` field to objects that appear more than once
	for (const arr of arrays) {
		for (const obj of arr) {
			const objString = JSON.stringify(obj);

			if (objString in objectCount && objectCount[objString] > 0) {
				obj.duplicate = objectCount[objString];
				objectCount[objString] = 0; // reset count to 0 to avoid marking duplicates again
			}
		}
	}

	for (let i = 0; i < arrays.length - 1; i++) {
		const arr = arrays[i];
		const nextArr = arrays[i + 1];
		for (const obj of arr) {
			obj.x = i;
		}
		for (const obj of nextArr) {
			obj.x = i + 1;
		}
	}

	// Return a new array containing all the objects with the `duplicate` field added where appropriate
	return arrays.flat();
}

function removeDuplicateObjects(arr) {
	const uniqueObjects = {};
	const result = [];

	// Loop through the array of objects
	for (const obj of arr) {
		// If an object with the same id already exists, skip it
		if (uniqueObjects[obj.session_id]) {
			continue;
		}

		// Add the object to the uniqueObjects map and the result array
		uniqueObjects[obj.session_id] = true;
		result.push(obj);
	}

	return result;
}

export const convertToGridLayout = tracks => {
	const grid_layout = [];
	const allTrackSessions = [];

	tracks.map(track => {
		const assignedSessions = track.track_sessions.filter(
			session => session.track_assigned === true
		);
		allTrackSessions.push(assignedSessions);
	});

	let allObj = markDuplicateObjects(...allTrackSessions);
	allObj = removeDuplicateObjects(allObj);

	const timeArr = getTimesArray(tracks[0].start_time, tracks[0].end_time, 15, true);

	allObj.forEach(session => {
		const sessionLayout = {};
		sessionLayout.x = session.x;
		sessionLayout.w = session.hasOwnProperty("duplicate") ? session.duplicate + 1 : 1;
		const startTimeIndex = timeArr.indexOf(session.start_timestamp.split(" ")[1]);
		const endTimeIndex = timeArr.indexOf(session.end_timestamp.split(" ")[1]);
		sessionLayout.y = startTimeIndex;
		sessionLayout.h = endTimeIndex - startTimeIndex;
		sessionLayout.i = session.session_id;
		sessionLayout.session = session;
		grid_layout.push(sessionLayout);
	});

	return grid_layout;
};

export function findMatchingsessionsById(arr1, arr2) {
	// Create a Map to store objects by ID from the second array
	const objMap = new Map();
	for (const obj of arr2) {
		objMap.set(obj.session_id, obj);
	}

	// Create an empty array to store the matching objects
	const matchingObjects = [];

	// Loop through the first array of objects
	for (const obj of arr1) {
		const id = obj.session_id;
		const matchingObj = objMap.get(id);

		// If a matching object was found, add it to the matchingObjects array
		if (matchingObj) {
			matchingObjects.push(matchingObj);
		}
	}

	// Return the array of matching objects
	return matchingObjects;
}

export function deleteObjectFields(obj, prop) {
	for (const p of prop) {
		delete obj[p];
	}
}

export const createBaseSessions = async (selectedDate, eventInfo) => {
	const sessions = ["Refreshment Break", "Lunch Time", "Fun Time"];

	// set initial value for add/edit session modal
	await sessions.forEach(async (sessionName, i) => {
		const payload = {
			session_title: sessionName,
			session_description: "",
			session_type: 4,
			start_timestamp: getISTDateNTime(
				`${selectedDate} ${eventInfo.start_time}`,
				eventInfo.time_zone
			),
			end_timestamp: getISTDateNTime(
				new Date(`${selectedDate} ${eventInfo.start_time}`).setHours(
					new Date().getHours() + 1
				),
				eventInfo.time_zone
			),
			session_order: i + 1,
			session_speakers: [],
			track_assigned: i === 0 ? true : false,
			session_colour: i == 1 ? "#E4EFFB" : i == 2 ? "#FFECD3" : "#DEF6E9",
			grid_layout: i === 0 ? { x: 0, y: 0, w: 1, h: 2 } : null
		};

		try {
			const res = await addSessions(eventInfo.event_id, payload);
		} catch (err) {
			console.log(err);
		}
	});
};

export const calculateHeight = session => {
	const difference =
		new Date(session.end_timestamp).getTime() - new Date(session.start_timestamp).getTime();
	const resultInMinutes = Math.round(difference / 60000);
	return (resultInMinutes / 15).toFixed(2);
};

export const calculateY = (session, tracksData, timeZone, selectedDate, noConvertToITC = false) => {
	if (selectedDate !== session.start_timestamp.split(" ")[0] && session?.grid_layout?.y)
		return session.grid_layout.y;
	const startTimeString = _.isEmpty(tracksData) ? 0 : tracksData[0].start_time;
	//getISTDateNTime(`${selectedDate} ${tracksData[0].start_time}`, timeZone, false, "HH:mm");
	let sessionStartTimeString = "";
	if (noConvertToITC)
		sessionStartTimeString = `${addZero(
			new Date(session.start_timestamp).getHours()
		)}:${addZero(new Date(session.start_timestamp).getMinutes())}`;
	else sessionStartTimeString = session.start_timestamp.split(" ")[1] + ":00";
	//getISTDateNTime(`${session.start_timestamp}`, timeZone, false, "HH:mm");

	const startTime = new Date(`${selectedDate} ${startTimeString}`).getTime();
	const sessionStartTime = new Date(`${selectedDate} ${sessionStartTimeString}`).getTime();

	//console.log(startTimeString, sessionStartTimeString, `${selectedDate} ${startTimeString}`, `${selectedDate} ${sessionStartTimeString}`)
	//console.log(new Date(`${selectedDate} ${startTimeString}`).getTime(), new Date(`${selectedDate} ${sessionStartTimeString}`).getTime())
	//console.log(parseFloat(((sessionStartTime - startTime) / 60000) / 15).toFixed(2))

	return parseFloat((sessionStartTime - startTime) / 60000 / 15).toFixed(2);
};

export const generateGridLayout = (
	session,
	tracksData,
	timeZone,
	selectedDate,
	noConvertToITC,
	startingTrack = 0
) => {
	const gridLayout = session.grid_layout || {};
	gridLayout.h = +parseFloat(calculateHeight(session)).toFixed(2);
	gridLayout.y = +parseFloat(
		calculateY(session, tracksData, timeZone, selectedDate, noConvertToITC)
	).toFixed(2);
	gridLayout.x = gridLayout.x || startingTrack;
	gridLayout.w = gridLayout.w || 1;
	gridLayout.i = session.session_id;
	return gridLayout;
};

export const checkIfOverLaps = (
	session,
	sessionsGridLayout,
	tracksData,
	timeZone,
	selectedDate,
	noConvertToITC,
	startingTrack
) => {
	if (session.session_id && session.session_id === sessionsGridLayout.session.session_id)
		return { session: sessionsGridLayout.session, overlapping: false };
	const gridLayout =
		session.grid_layout ||
		generateGridLayout(
			session,
			tracksData,
			timeZone,
			selectedDate,
			noConvertToITC,
			startingTrack
		);
	const rect1X = [gridLayout.x, gridLayout.x + gridLayout.w];
	const rect1Y = [gridLayout.y, gridLayout.y + gridLayout.h];
	const rect2X = [sessionsGridLayout.x, sessionsGridLayout.x + sessionsGridLayout.w];
	const rect2Y = [sessionsGridLayout.y, sessionsGridLayout.y + sessionsGridLayout.h];

	// Check if rectangle 1 overlaps rectangle 2 in the X direction
	const xOverlap = rect1X[0] < rect2X[1] && rect2X[0] < rect1X[1];

	// Check if rectangle 1 overlaps rectangle 2 in the Y direction
	const yOverlap = rect1Y[0] < rect2Y[1] && rect2Y[0] < rect1Y[1];
	//console.log(xOverlap, yOverlap)

	// Check if rectangle 1 overlaps rectangle 2
	if (yOverlap && xOverlap) {
		return { session: sessionsGridLayout.session, overlapping: true };
	}
	return { session: sessionsGridLayout.session, overlapping: false };
};

//converting custom from name
const customStripHtmlTags = htmlString => {
	const doc = new DOMParser().parseFromString(htmlString, "text/html");
	const body = doc.body;
	return body.childNodes.length > 0 ? body.childNodes[0].textContent : "";
};

export const fetchCustomFormName = (
	displayName,
	fieldName,
	checkboxesSection = ""
) => {
	if (!displayName) return null;

	// Sanitize fully — allow text only
	const cleaned = DOMPurify.sanitize(displayName, { ALLOWED_TAGS: [] })
		.replace(/_/g, " ")
		.trim();

	const formatted = capitalizeFirst(cleaned);

	const className =
		fieldName !== "email_id" &&
			fieldName !== "name" &&
			checkboxesSection === downloadAttendeesCheckboxesSection.ATTENDEE_DETAILS
			? "truncate-multiline"
			: "";

	if (!fieldName) {
		return <span>{formatted}</span>;
	}

	return (
		<label htmlFor={fieldName} className={className}>
			{formatted}
		</label>
	);
};


export const fetchCustomFormNameWithDecoding = (displayName, fieldName) => {
	const decodedDisplayName = decodeFormNames(displayName);
	const strippedHtml = customStripHtmlTags(
		decodedDisplayName?.replace(/(?:\r\n|\r|\n)/g, "") || ""
	);
	const capitalizedText = capitalizeFirst(strippedHtml);

	if (decodedDisplayName && !fieldName) {
		return React.createElement("span", {
			dangerouslySetInnerHTML: {
				__html: capitalizedText.replace(/_/g, " ")
			}
		});
	}
	if (decodedDisplayName && fieldName) {
		return React.createElement("label", {
			for: fieldName,
			dangerouslySetInnerHTML: {
				__html: capitalizedText.replace(/_/g, " ")
			}
		});
	}
};

export const encodeFormNames = formName => {
	return formName
		.replaceAll(".", "<FullStop>")
		.replaceAll("[", "<OpenSquareBracket>")
		.replaceAll("]", "<CloseSquareBracket>");
};

export const decodeFormNames = formName => {
	return formName
		.replaceAll("<FullStop>", ".")
		.replaceAll("<OpenSquareBracket>", "[")
		.replaceAll("<CloseSquareBracket>", "]");
};

//converting predefined from name
const stripHtmlTags = htmlString => {
	const doc = new DOMParser().parseFromString(htmlString, "text/html");
	const body = doc.body;

	// Iterate through all anchor tags
	body.querySelectorAll("a").forEach(anchor => {
		// Set target attribute to '_blank' for all anchor tags
		anchor.setAttribute("target", "_blank");

		// Set the color of the anchor text to blue
		anchor.style.color = "blue";

		// Convert any child tags to plain text
		anchor.childNodes.forEach(child => {
			if (child.nodeType === Node.ELEMENT_NODE) {
				const textNode = doc.createTextNode(child.textContent);
				child.replaceWith(textNode);
			}
		});
	});

	return body.innerHTML;
};

export const fetchFormName = (val) => {
	return React.createElement("span", {
		dangerouslySetInnerHTML: {
			__html: stripHtmlTags(
				val?.replace(/(?:\r\n|\r|\n)/g, "") || ""
			).replace(/<p[^>]*>/g, '<p style="margin: 0;">')
		}
	});
};

export const addFifteenDaysToEventDateAndTime = (endDate, endTime) => {
	// Given date and time
	const givenDateTime = new Date(`${endDate}T${endTime}`);

	// Add 15 days to the given date
	givenDateTime.setDate(givenDateTime.getDate() + 15);
	return givenDateTime;
};

export function checkPotentialDomainTypo(email) {
	// Extract the domain after "@"
	const domain = email?.split("@")[1]?.toLowerCase() || "";

	// Define a list of common typos (modify this list as needed)
	const commonTypos = [
		"gmal.com",
		"gnail.com",
		"gamal.com",
		"gmal.com",
		"gamil.com",
		"gaml.com",
		"gmail.in",
		"gmail.co",
		"gmail.in",
		"gemail.com",
		"hotmal.com",
		"yaho.com"
	];
	// Check if the domain exists in the list
	if (domain) {
		return commonTypos.includes(domain) ? true : false;
	}

	// No match found or invalid email format
	return true;
}

export const CurrencyWithAmount = ({
	currencyName,
	number,
	removeNegativeFromNumber = false,
	className,
	style,
	fontSize
}) => {
	//return currency with an number having comas based on the region, with a space between them, up to 2 decimal places. Example: ₹ 16,315.26

	const listOfCurrencyDifferentFormat = {
		// list of currency where the currency symbol comes after the amount e.g. 2.00 د.إ
		AED: "ar-AE",
		CHF: "de-CH",
		CZK: "cs-CZ",
		DKK: "da-DK",
		HUF: "hu-HU",
		NOK: "nb-NO",
		PLN: "pl-PL",
		SEK: "sv-SE"
	};

	const listOfNonStandardNumericCurrencies = {
		BDT: "bn-BD",
		EGP: "ar-EG",
		LBP: "ar-LB",
		QAR: "ar-QA",
		SAR: "ar-SA",
		YER: "ar-YE"
	};

	const ifCurrencyExist = () => {
		// return true if currency exist in listOfCurrencyDifferentFormat
		if (Object.keys(listOfCurrencyDifferentFormat).includes(currencyName)) {
			return true;
		}
		return false;
	};

	function getLocaleFromCurrency(currency) {
		const upperCaseCurrency = currency?.toUpperCase();
		if (
			Object.prototype.hasOwnProperty.call(
				listOfNonStandardNumericCurrencies,
				upperCaseCurrency
			)
		) {
			return "sv-SE";
		}
		if (Object.prototype.hasOwnProperty.call(currencyLocaleMap, upperCaseCurrency)) {
			return currencyLocaleMap[upperCaseCurrency];
		}
		// Default to en-IN for unknown currencies
		return "en-IN";
	}

	const _number = removeNegativeFromNumber ? Math.abs(number) : number; // remove negative sign

	const _threeDecimalCurrencies = new Set(threeDecimalCurrencies);
	const _zeroDecimalCurrencies = new Set(zeroDecimalCurrencies);

	// Convert the input number to a Number object and format it as currency
	const formattedNumber = Number(_number).toLocaleString(getLocaleFromCurrency(currencyName), {
		maximumFractionDigits: _threeDecimalCurrencies.has(currencyName) ? 3 : _zeroDecimalCurrencies.has(currencyName) ? 0 : 2, // Set the maximum number of decimal places to 2
		minimumFractionDigits: _threeDecimalCurrencies.has(currencyName) ? 3 : _zeroDecimalCurrencies.has(currencyName) ? 0 : 2 // Set the minimum number of decimal places to 2
	});

	function formatString(string) {
		// Remove trailing '.00' if present
		if (string.endsWith(".00") || string.endsWith(",00")) {
			return string.slice(0, -3); // Remove last 3 characters
		}
		return string; // Otherwise return the string as is
	}

	// return `${currencyName === "AUD" ? "A" : ""}${getSymbolFromCurrency(currencyName)} ${formattedNumber}`
	return (
		<>
			{ifCurrencyExist(currencyName) ? (
				<>
					<span style={{ marginRight: "3.5px" }}>{formatString(formattedNumber)}</span>
					<GetCurrency
						currency={currencyName}
						className={className}
						style={style}
						fontSize={fontSize}
					/>
				</>
			) : (
				<>
					<GetCurrency
						currency={currencyName}
						className={className}
						style={style}
						fontSize={fontSize}
					/>
					<span style={{ marginLeft: "3.5px" }}>{formatString(formattedNumber)}</span>
				</>
			)}
		</>
	);
};

export const IndianState = [
	{ label: "Andhra Pradesh", value: "AP" },
	{ label: "Arunachal Pradesh", value: "AR" },
	{ label: "Assam", value: "AS" },
	{ label: "Bihar", value: "BR" },
	{ label: "Chhattisgarh", value: "CG" },
	{ label: "Goa", value: "GA" },
	{ label: "Gujarat", value: "GJ" },
	{ label: "Haryana", value: "HR" },
	{ label: "Himachal Pradesh", value: "HP" },
	{ label: "Jammu and Kashmir", value: "JK" },
	{ label: "Jharkhand", value: "JH" },
	{ label: "Karnataka", value: "KA" },
	{ label: "Kerala", value: "KL" },
	{ label: "Madhya Pradesh", value: "MP" },
	{ label: "Maharashtra", value: "MH" },
	{ label: "Manipur", value: "MN" },
	{ label: "Meghalaya", value: "ML" },
	{ label: "Mizoram", value: "MZ" },
	{ label: "Nagaland", value: "NL" },
	{ label: "Odisha", value: "OD" },
	{ label: "Punjab", value: "PB" },
	{ label: "Rajasthan", value: "RJ" },
	{ label: "Sikkim", value: "SK" },
	{ label: "Tamil Nadu", value: "TN" },
	{ label: "Telangana", value: "TS" },
	{ label: "Tripura", value: "TR" },
	{ label: "Uttarakhand", value: "UK" },
	{ label: "Uttar Pradesh", value: "UP" },
	{ label: "West Bengal", value: "WB" },
	{ label: "Andaman and Nicobar Islands", value: "AN" },
	{ label: "Chandigarh", value: "CH" },
	{ label: "Dadra and Nagar Haveli", value: "DN" },
	{ label: "Daman and Diu", value: "DDD" },
	{ label: "Delhi", value: "DL" },
	{ label: "Lakshadweep", value: "LD" },
	{ label: "Puducherry", value: "PY" }
];

export const eventLevelOptions = [
	{ value: "AED", label: "AED" },
	{ value: "AUD", label: "AUD" },
	{ value: "BGN", label: "BGN" },
	{ value: "BRL", label: "BRL" },
	{ value: "CAD", label: "CAD" },
	{ value: "CHF", label: "CHF" },
	{ value: "CZK", label: "CZK" },
	{ value: "DKK", label: "DKK" },
	{ value: "EUR", label: "EUR" },
	{ value: "GBP", label: "GBP" },
	{ value: "HKD", label: "HKD" },
	{ value: "HUF", label: "HUF" },
	{ value: "INR", label: "INR" },
	// { value: "KWD", label: "KWD"},
	{ value: "MYR", label: "MYR" },
	{ value: "MXN", label: "MXN" },
	{ value: "NOK", label: "NOK" },
	{ value: "NZD", label: "NZD" },
	{ value: "PHP", label: "PHP" },
	{ value: "PLN", label: "PLN" },
	{ value: "RON", label: "RON" },
	{ value: "SEK", label: "SEK" },
	{ value: "SGD", label: "SGD" },
	{ value: "THB", label: "THB" },
	{ value: "USD", label: "USD" },
	{ value: "BHD", label: "BHD" },
	{ value: "OMR", label: "OMR" },
	{ value: "KWD", label: "KWD" },
	{ value: "EGP", label: "EGP" },
	{ value: "QAR", label: "QAR" },
	{ value: "SAR", label: "SAR" },
	{ value: "LBP", label: "LBP" },

];

export const ticketLevelOptions = [
	{ value: "INR", label: "INR" },
	{ value: "USD", label: "USD" },
	{ value: "AMD", label: "AMD" },
	{ value: "ARS", label: "ARS" },
	{ value: "AUD", label: "AUD" },
	{ value: "AWG", label: "AWG" },
	{ value: "BBD", label: "BBD" },
	{ value: "BDT", label: "BDT" },
	{ value: "BMD", label: "BMD" },
	{ value: "BND", label: "BND" },
	{ value: "BOB", label: "BOB" },
	{ value: "BSD", label: "BSD" },
	{ value: "BWP", label: "BWP" },
	{ value: "BZD", label: "BZD" },
	{ value: "CAD", label: "CAD" },
	{ value: "CHF", label: "CHF" },
	{ value: "CNY", label: "CNY" },
	{ value: "COP", label: "COP" },
	{ value: "CRC", label: "CRC" },
	{ value: "CUP", label: "CUP" },
	{ value: "CZK", label: "CZK" },
	{ value: "DKK", label: "DKK" },
	{ value: "DOP", label: "DOP" },
	{ value: "DZD", label: "DZD" },
	{ value: "EGP", label: "EGP" },
	{ value: "ETB", label: "ETB" },
	{ value: "EUR", label: "EUR" },
	{ value: "FJD", label: "FJD" },
	{ value: "GBP", label: "GBP" },
	{ value: "GIP", label: "GIP" },
	{ value: "GHS", label: "GHS" },
	{ value: "GMD", label: "GMD" },
	{ value: "GTQ", label: "GTQ" },
	{ value: "GYD", label: "GYD" },
	{ value: "HKD", label: "HKD" },
	{ value: "HNL", label: "HNL" },
	{ value: "HRK", label: "HRK" },
	{ value: "HTG", label: "HTG" },
	{ value: "HUF", label: "HUF" },
	{ value: "IDR", label: "IDR" },
	{ value: "ILS", label: "ILS" },
	{ value: "AED", label: "AED" },
	{ value: "JMD", label: "JMD" },
	{ value: "KES", label: "KES" },
	{ value: "KGS", label: "KGS" },
	{ value: "KHR", label: "KHR" },
	{ value: "KYD", label: "KYD" },
	{ value: "KZT", label: "KZT" },
	{ value: "LAK", label: "LAK" },
	{ value: "LBP", label: "LBP" },
	{ value: "LKR", label: "LKR" },
	{ value: "LRD", label: "LRD" },
	{ value: "LSL", label: "LSL" },
	{ value: "MAD", label: "MAD" },
	{ value: "MDL", label: "MDL" },
	{ value: "MKD", label: "MKD" },
	{ value: "MMK", label: "MMK" },
	{ value: "MNT", label: "MNT" },
	{ value: "MOP", label: "MOP" },
	{ value: "MUR", label: "MUR" },
	{ value: "MVR", label: "MVR" },
	{ value: "MWK", label: "MWK" },
	{ value: "MXN", label: "MXN" },
	{ value: "MYR", label: "MYR" },
	{ value: "NAD", label: "NAD" },
	{ value: "NGN", label: "NGN" },
	{ value: "NIO", label: "NIO" },
	{ value: "NOK", label: "NOK" },
	{ value: "NPR", label: "NPR" },
	{ value: "NZD", label: "NZD" },
	{ value: "PEN", label: "PEN" },
	{ value: "PGK", label: "PGK" },
	{ value: "PHP", label: "PHP" },
	{ value: "PKR", label: "PKR" },
	{ value: "QAR", label: "QAR" },
	{ value: "RUB", label: "RUB" },
	{ value: "SAR", label: "SAR" },
	{ value: "SCR", label: "SCR" },
	{ value: "SEK", label: "SEK" },
	{ value: "SGD", label: "SGD" },
	{ value: "SLL", label: "SLL" },
	{ value: "SOS", label: "SOS" },
	{ value: "SSP", label: "SSP" },
	{ value: "SVC", label: "SVC" },
	{ value: "SZL", label: "SZL" },
	{ value: "THB", label: "THB" },
	{ value: "TTD", label: "TTD" },
	{ value: "TZS", label: "TZS" },
	{ value: "ALL", label: "ALL" },
	{ value: "UYU", label: "UYU" },
	{ value: "UZS", label: "UZS" },
	{ value: "YER", label: "YER" },
	{ value: "ZAR", label: "ZAR" },
	{ value: "BHD", label: "BHD" },
	{ value: "OMR", label: "OMR" },
	{ value: "KWD", label: "KWD" },
	{ value: "EGP", label: "EGP" },
	{ value: "QAR", label: "QAR" },
	{ value: "SAR", label: "SAR" }
];

export const INTERNATIONAL_STRIPE_SUPPORTED = [
	{
		value: "AED",
		label: "AED"
	},
	{
		value: "AFN",
		label: "AFN"
	},
	{
		value: "ALL",
		label: "ALL"
	},
	{
		value: "AMD",
		label: "AMD"
	},
	{
		value: "ANG",
		label: "ANG"
	},
	{
		value: "AOA",
		label: "AOA"
	},
	{
		value: "ARS",
		label: "ARS"
	},
	{
		value: "AUD",
		label: "AUD"
	},
	{
		value: "AWG",
		label: "AWG"
	},
	{
		value: "AZN",
		label: "AZN"
	},
	{
		value: "BAM",
		label: "BAM"
	},
	{
		value: "BBD",
		label: "BBD"
	},
	{
		value: "BDT",
		label: "BDT"
	},
	{
		value: "BGN",
		label: "BGN"
	},
	{
		value: "BHD",
		label: "BHD"
	},
	{
		value: "BIF",
		label: "BIF"
	},
	{
		value: "BMD",
		label: "BMD"
	},
	{
		value: "BND",
		label: "BND"
	},
	{
		value: "BOB",
		label: "BOB"
	},
	{
		value: "BRL",
		label: "BRL"
	},
	{
		value: "BSD",
		label: "BSD"
	},
	{
		value: "BWP",
		label: "BWP"
	},
	{
		value: "BYN",
		label: "BYN"
	},
	{
		value: "BZD",
		label: "BZD"
	},
	{
		value: "CAD",
		label: "CAD"
	},
	{
		value: "CDF",
		label: "CDF"
	},
	{
		value: "CHF",
		label: "CHF"
	},
	{
		value: "CLP",
		label: "CLP"
	},
	{
		value: "CNY",
		label: "CNY"
	},
	{
		value: "COP",
		label: "COP"
	},
	{
		value: "CRC",
		label: "CRC"
	},
	{
		value: "CVE",
		label: "CVE"
	},
	{
		value: "CZK",
		label: "CZK"
	},
	{
		value: "DJF",
		label: "DJF"
	},
	{
		value: "DKK",
		label: "DKK"
	},
	{
		value: "DOP",
		label: "DOP"
	},
	{
		value: "DZD",
		label: "DZD"
	},
	{
		value: "EGP",
		label: "EGP"
	},
	{
		value: "ETB",
		label: "ETB"
	},
	{
		value: "EUR",
		label: "EUR"
	},
	{
		value: "FJD",
		label: "FJD"
	},
	{
		value: "FKP",
		label: "FKP"
	},
	{
		value: "GBP",
		label: "GBP"
	},
	{
		value: "GEL",
		label: "GEL"
	},
	{
		value: "GIP",
		label: "GIP"
	},
	{
		value: "GMD",
		label: "GMD"
	},
	{
		value: "GNF",
		label: "GNF"
	},
	{
		value: "GTQ",
		label: "GTQ"
	},
	{
		value: "GYD",
		label: "GYD"
	},
	{
		value: "HKD",
		label: "HKD"
	},
	{
		value: "HNL",
		label: "HNL"
	},
	{
		value: "HRK",
		label: "HRK"
	},
	{
		value: "HTG",
		label: "HTG"
	},
	{
		value: "HUF",
		label: "HUF"
	},
	{
		value: "IDR",
		label: "IDR"
	},
	{
		value: "ILS",
		label: "ILS"
	},
	{
		value: "INR",
		label: "INR"
	},
	{
		value: "ISK",
		label: "ISK"
	},
	{
		value: "JMD",
		label: "JMD"
	},
	{
		value: "JOD",
		label: "JOD"
	},
	{
		value: "JPY",
		label: "JPY"
	},
	{
		value: "KES",
		label: "KES"
	},
	{
		value: "KGS",
		label: "KGS"
	},
	{
		value: "KHR",
		label: "KHR"
	},
	{
		value: "KMF",
		label: "KMF"
	},
	{
		value: "KRW",
		label: "KRW"
	},
	{
		value: "KWD",
		label: "KWD"
	},
	{
		value: "KYD",
		label: "KYD"
	},
	{
		value: "KZT",
		label: "KZT"
	},
	{
		value: "LAK",
		label: "LAK"
	},
	{
		value: "LBP",
		label: "LBP"
	},
	{
		value: "LKR",
		label: "LKR"
	},
	{
		value: "LRD",
		label: "LRD"
	},
	{
		value: "LSL",
		label: "LSL"
	},
	{
		value: "MAD",
		label: "MAD"
	},
	{
		value: "MDL",
		label: "MDL"
	},
	{
		value: "MGA",
		label: "MGA"
	},
	{
		value: "MKD",
		label: "MKD"
	},
	{
		value: "MMK",
		label: "MMK"
	},
	{
		value: "MNT",
		label: "MNT"
	},
	{
		value: "MOP",
		label: "MOP"
	},
	{
		value: "MUR",
		label: "MUR"
	},
	{
		value: "MVR",
		label: "MVR"
	},
	{
		value: "MWK",
		label: "MWK"
	},
	{
		value: "MXN",
		label: "MXN"
	},
	{
		value: "MYR",
		label: "MYR"
	},
	{
		value: "MZN",
		label: "MZN"
	},
	{
		value: "NAD",
		label: "NAD"
	},
	{
		value: "NGN",
		label: "NGN"
	},
	{
		value: "NIO",
		label: "NIO"
	},
	{
		value: "NOK",
		label: "NOK"
	},
	{
		value: "NPR",
		label: "NPR"
	},
	{
		value: "NZD",
		label: "NZD"
	},
	{
		value: "OMR",
		label: "OMR"
	},
	{
		value: "PAB",
		label: "PAB"
	},
	{
		value: "PEN",
		label: "PEN"
	},
	{
		value: "PGK",
		label: "PGK"
	},
	{
		value: "PHP",
		label: "PHP"
	},
	{
		value: "PKR",
		label: "PKR"
	},
	{
		value: "PLN",
		label: "PLN"
	},
	{
		value: "PYG",
		label: "PYG"
	},
	{
		value: "QAR",
		label: "QAR"
	},
	{
		value: "RON",
		label: "RON"
	},
	{
		value: "RSD",
		label: "RSD"
	},
	{
		value: "RUB",
		label: "RUB"
	},
	{
		value: "RWF",
		label: "RWF"
	},
	{
		value: "SAR",
		label: "SAR"
	},
	{
		value: "SBD",
		label: "SBD"
	},
	{
		value: "SCR",
		label: "SCR"
	},
	{
		value: "SEK",
		label: "SEK"
	},
	{
		value: "SGD",
		label: "SGD"
	},
	{
		value: "SHP",
		label: "SHP"
	},
	{
		value: "SLE",
		label: "SLE"
	},
	{
		value: "SOS",
		label: "SOS"
	},
	{
		value: "SRD",
		label: "SRD"
	},
	{
		value: "STD",
		label: "STD"
	},
	{
		value: "SZL",
		label: "SZL"
	},
	{
		value: "THB",
		label: "THB"
	},
	{
		value: "TJS",
		label: "TJS"
	},
	{
		value: "TND",
		label: "TND"
	},
	{
		value: "TOP",
		label: "TOP"
	},
	{
		value: "TRY",
		label: "TRY"
	},
	{
		value: "TTD",
		label: "TTD"
	},
	{
		value: "TWD",
		label: "TWD"
	},
	{
		value: "TZS",
		label: "TZS"
	},
	{
		value: "UAH",
		label: "UAH"
	},
	{
		value: "UGX",
		label: "UGX"
	},
	{
		value: "USD",
		label: "USD"
	},
	{
		value: "UYU",
		label: "UYU"
	},
	{
		value: "UZS",
		label: "UZS"
	},
	{
		value: "VND",
		label: "VND"
	},
	{
		value: "VUV",
		label: "VUV"
	},
	{
		value: "WST",
		label: "WST"
	},
	{
		value: "XAF",
		label: "XAF"
	},
	{
		value: "XCD",
		label: "XCD"
	},
	{
		value: "XOF",
		label: "XOF"
	},
	{
		value: "XPF",
		label: "XPF"
	},
	{
		value: "YER",
		label: "YER"
	},
	{
		value: "ZAR",
		label: "ZAR"
	},
	{
		value: "ZMW",
		label: "ZMW"
	}
]

export const INTERNATIONAL_TAP_SUPPORTED = [
	{ value: 'AED', label: 'AED' },
	{ value: 'BHD', label: 'BHD' },
	{ value: 'EUR', label: 'EUR' },
	{ value: 'GBP', label: 'GBP' },
	{ value: 'KWD', label: 'KWD' },
	{ value: 'OMR', label: 'OMR' },
	{ value: 'QAR', label: 'QAR' },
	{ value: 'SAR', label: 'SAR' },
	{ value: 'USD', label: 'USD' }
];

export const AREEBA_SUPPORTED_COUNTRIES = [
	{ value: 'EG', label: 'Egypt' },
	{ value: 'JO', label: 'Jordan' },
	{ value: 'LB', label: 'Lebanon' },
	{ value: 'QA', label: 'Qatar' },
	{ value: 'AE', label: 'United Arab Emirates' },
	{ value: 'IQ', label: 'Iraq' }
];




export const featureRestrictions = {
	1: ["Email Templates",
		"Event Page Templates",
		"Only 3 Emails campaigns",
		"White Label",
		"Email",
		"Sponsor App",
		"Integrations",
		"Registeration Buttons",
		"Reg. Buttons",
		"Embed Tickets",
		"Embed tickets",
		"Webhooks",
		"Webhook",
		"Analytics",
	],
	2: [
		// Lite plan feature restrictions
		"No international ticket",
		"Only 3 Emails campaigns",
		"Referral Contest",
		"Quiz",
		"Feedback Forms",
		"Sponsor App",
		"Email Templates",
		"Event Page Templates",
		"White Label",
		"Integrations",
		"Registeration Buttons",
		"Reg. Buttons",
		"Embed Tickets",
		"Embed tickets",
		"Webhooks",
		"Webhook",
		"Analytics",
	],
	3: ["White Label"]
};

export const isFeatureRestricted = (plan, featureName) => {
	if (featureRestrictions[plan]?.includes(featureName)) return true;
	return false;
};

export const addNullForEmptyString = data => {
	let updatedValues = {};
	Object.keys(data).map(key => {
		if (data[key] === "") updatedValues = { ...updatedValues, [key]: null };
		else updatedValues = { ...updatedValues, [key]: data[key] };
	});
	return updatedValues;
};

export const isValidUrl = url => {
	try {
		url = new URL(url);
	} catch (e) {
		return false;
	}
	return url.protocol === "http:" || url.protocol === "https:";
};

export const eventCity = (city) => {
	return {
		isDubaiEvent: city === "Dubai" || city === "dubai",
	};
};

export const eventStatus = {
	liveEvents: 1,
	upcomingEvents: 2,
	pastEvents: 3
}

export const CURRENCY_TO_CURRENCY_ID_LOOKUP = {
	"INR": 1,
	"USD": 2,
	"AMD": 3,
	"ARS": 4,
	"AUD": 5,
	"AWG": 6,
	"BBD": 7,
	"BDT": 8,
	"BMD": 9,
	"BND": 10,
	"BOB": 11,
	"BSD": 12,
	"BWP": 13,
	"BZD": 14,
	"CAD": 15,
	"CHF": 16,
	"CNY": 17,
	"COP": 18,
	"CRC": 19,
	"CUP": 20,
	"CZK": 21,
	"DKK": 22,
	"DOP": 23,
	"DZD": 24,
	"EGP": 25,
	"ETB": 26,
	"EUR": 27,
	"FJD": 28,
	"GBP": 29,
	"GIP": 30,
	"GHS": 31,
	"GMD": 32,
	"GTQ": 33,
	"GYD": 34,
	"HKD": 35,
	"HNL": 36,
	"HRK": 37,
	"HTG": 38,
	"HUF": 39,
	"IDR": 40,
	"ILS": 41,
	"AED": 42,
	"JMD": 43,
	"KES": 44,
	"KGS": 45,
	"KHR": 46,
	"KYD": 47,
	"KZT": 48,
	"LAK": 49,
	"LBP": 50,
	"LKR": 51,
	"LRD": 52,
	"LSL": 53,
	"MAD": 54,
	"MDL": 55,
	"MKD": 56,
	"MMK": 57,
	"MNT": 58,
	"MOP": 59,
	"MUR": 60,
	"MVR": 61,
	"MWK": 62,
	"MXN": 63,
	"MYR": 64,
	"NAD": 65,
	"NGN": 66,
	"NIO": 67,
	"NOK": 68,
	"NPR": 69,
	"NZD": 70,
	"PEN": 71,
	"PGK": 72,
	"PHP": 73,
	"PKR": 74,
	"QAR": 75,
	"RUB": 76,
	"SAR": 77,
	"SCR": 78,
	"SEK": 79,
	"SGD": 80,
	"SLL": 81,
	"SOS": 82,
	"SSP": 83,
	"SVC": 84,
	"SZL": 85,
	"THB": 86,
	"TTD": 87,
	"TZS": 88,
	"ALL": 89,
	"UYU": 90,
	"UZS": 91,
	"YER": 92,
	"ZAR": 93,
	"JPY": 94,
	"KWD": 95,
	"BRL": 96,
	"BGN": 97,
	"PLN": 98,
	"RON": 99,
	"BHD": 100,
	"OMR": 101,
}


export const fetchCheckinOptions = async () => {
	try {
		const result = await getAllMultiCheckins();

		// Convert API response to dropdown-friendly format
		const checkinOptions = result.data.custom_checkins.map((checkin) => ({
			label: checkin.checkin_name,
			value: checkin.checkin_id,
			is_default: checkin.is_default,
			checkin_order: checkin.checkin_order,
		}));

		// Sort by checkin_order in ascending order
		const sortedCheckinOptions = [...checkinOptions].sort((a, b) => a.checkin_order - b.checkin_order);

		const defaultCheckin = sortedCheckinOptions.find((checkin) => checkin.is_default) || sortedCheckinOptions[0];

		return { checkinOptions: sortedCheckinOptions, defaultCheckin, allCheckins: result.data.custom_checkins };
	} catch (error) {
		console.error("Error fetching checkins:", error);
		return { checkinOptions: [], defaultCheckin: null };
	}
};

export const CURRENCY_MAPPING = {
	AED: { name: "United Arab Emirates Dirham", symbol: "د.إ" },
	AFN: { name: "Afghan Afghani", symbol: "؋" },
	ALL: { name: "Albanian Lek", symbol: "L" },
	AMD: { name: "Armenian Dram", symbol: "֏" },
	ANG: { name: "Netherlands Antillean Guilder", symbol: "ƒ" },
	AOA: { name: "Angolan Kwanza", symbol: "Kz" },
	ARS: { name: "Argentine Peso", symbol: "$" },
	AUD: { name: "Australian Dollar", symbol: "A$" },
	AWG: { name: "Aruban Florin", symbol: "ƒ" },
	AZN: { name: "Azerbaijani Manat", symbol: "₼" },
	BAM: { name: "Bosnia-Herzegovina Convertible Mark", symbol: "KM" },
	BBD: { name: "Barbadian Dollar", symbol: "Bds$" },
	BDT: { name: "Bangladeshi Taka", symbol: "৳" },
	BGN: { name: "Bulgarian Lev", symbol: "лв" },
	BHD: { name: "Bahraini Dinar", symbol: "ب.د" },
	BIF: { name: "Burundian Franc", symbol: "FBu" },
	BMD: { name: "Bermudian Dollar", symbol: "BD$" },
	BND: { name: "Brunei Dollar", symbol: "B$" },
	BOB: { name: "Bolivian Boliviano", symbol: "Bs." },
	BRL: { name: "Brazilian Real", symbol: "R$" },
	BSD: { name: "Bahamian Dollar", symbol: "B$" },
	BWP: { name: "Botswana Pula", symbol: "P" },
	BYN: { name: "Belarusian Ruble", symbol: "Br" },
	BZD: { name: "Belize Dollar", symbol: "BZ$" },
	CAD: { name: "Canadian Dollar", symbol: "CA$" },
	CDF: { name: "Congolese Franc", symbol: "FC" },
	CHF: { name: "Swiss Franc", symbol: "CHF" },
	CLP: { name: "Chilean Peso", symbol: "CLP$" },
	CNY: { name: "Chinese Yuan", symbol: "¥" },
	COP: { name: "Colombian Peso", symbol: "COL$" },
	CRC: { name: "Costa Rican Colón", symbol: "₡" },
	CVE: { name: "Cape Verdean Escudo", symbol: "Esc" },
	CZK: { name: "Czech Koruna", symbol: "Kč" },
	DJF: { name: "Djiboutian Franc", symbol: "Fdj" },
	DKK: { name: "Danish Krone", symbol: "kr" },
	DOP: { name: "Dominican Peso", symbol: "RD$" },
	DZD: { name: "Algerian Dinar", symbol: "د.ج" },
	EGP: { name: "Egyptian Pound", symbol: "£" },
	ETB: { name: "Ethiopian Birr", symbol: "Br" },
	EUR: { name: "Euro", symbol: "€" },
	FJD: { name: "Fijian Dollar", symbol: "FJ$" },
	FKP: { name: "Falkland Islands Pound", symbol: "£" },
	GBP: { name: "British Pound Sterling", symbol: "£" },
	GEL: { name: "Georgian Lari", symbol: "₾" },
	GIP: { name: "Gibraltar Pound", symbol: "£" },
	GMD: { name: "Gambian Dalasi", symbol: "D" },
	GNF: { name: "Guinean Franc", symbol: "FG" },
	GTQ: { name: "Guatemalan Quetzal", symbol: "Q" },
	GYD: { name: "Guyanese Dollar", symbol: "GY$" },
	HKD: { name: "Hong Kong Dollar", symbol: "HK$" },
	HNL: { name: "Honduran Lempira", symbol: "L" },
	HRK: { name: "Croatian Kuna", symbol: "kn" },
	HTG: { name: "Haitian Gourde", symbol: "G" },
	HUF: { name: "Hungarian Forint", symbol: "Ft" },
	IDR: { name: "Indonesian Rupiah", symbol: "Rp" },
	ILS: { name: "Israeli New Shekel", symbol: "₪" },
	INR: { name: "Indian Rupee", symbol: "₹" },
	ISK: { name: "Icelandic Króna", symbol: "kr" },
	JMD: { name: "Jamaican Dollar", symbol: "J$" },
	JOD: { name: "Jordanian Dinar", symbol: "د.ا" },
	JPY: { name: "Japanese Yen", symbol: "¥" },
	KES: { name: "Kenyan Shilling", symbol: "KSh" },
	KGS: { name: "Kyrgyzstani Som", symbol: "с" },
	KHR: { name: "Cambodian Riel", symbol: "៛" },
	KMF: { name: "Comorian Franc", symbol: "CF" },
	KRW: { name: "South Korean Won", symbol: "₩" },
	KWD: { name: "Kuwaiti Dinar", symbol: "د.ك" },
	KYD: { name: "Cayman Islands Dollar", symbol: "CI$" },
	KZT: { name: "Kazakhstani Tenge", symbol: "₸" },
	LAK: { name: "Lao Kip", symbol: "₭" },
	LBP: { name: "Lebanese Pound", symbol: "ل.ل" },
	LKR: { name: "Sri Lankan Rupee", symbol: "Rs" },
	LRD: { name: "Liberian Dollar", symbol: "L$" },
	LSL: { name: "Lesotho Loti", symbol: "L" },
	MAD: { name: "Moroccan Dirham", symbol: "د.م." },
	MDL: { name: "Moldovan Leu", symbol: "L" },
	MGA: { name: "Malagasy Ariary", symbol: "Ar" },
	MKD: { name: "Macedonian Denar", symbol: "ден" },
	MMK: { name: "Myanmar Kyat", symbol: "K" },
	MNT: { name: "Mongolian Tögrög", symbol: "₮" },
	MOP: { name: "Macanese Pataca", symbol: "MOP$" },
	MUR: { name: "Mauritian Rupee", symbol: "₨" },
	MVR: { name: "Maldivian Rufiyaa", symbol: "Rf" },
	MWK: { name: "Malawian Kwacha", symbol: "MK" },
	MXN: { name: "Mexican Peso", symbol: "MX$" },
	MYR: { name: "Malaysian Ringgit", symbol: "RM" },
	MZN: { name: "Mozambican Metical", symbol: "MT" },
	NAD: { name: "Namibian Dollar", symbol: "N$" },
	NGN: { name: "Nigerian Naira", symbol: "₦" },
	NIO: { name: "Nicaraguan Córdoba", symbol: "C$" },
	NOK: { name: "Norwegian Krone", symbol: "kr" },
	NPR: { name: "Nepalese Rupee", symbol: "₨" },
	NZD: { name: "New Zealand Dollar", symbol: "NZ$" },
	OMR: { name: "Omani Rial", symbol: "ر.ع." },
	PAB: { name: "Panamanian Balboa", symbol: "B/." },
	PEN: { name: "Peruvian Sol", symbol: "S/." },
	PGK: { name: "Papua New Guinean Kina", symbol: "K" },
	PHP: { name: "Philippine Peso", symbol: "₱" },
	PKR: { name: "Pakistani Rupee", symbol: "₨" },
	PLN: { name: "Polish Złoty", symbol: "zł" },
	PYG: { name: "Paraguayan Guaraní", symbol: "₲" },
	QAR: { name: "Qatari Riyal", symbol: "ر.ق" },
	RON: { name: "Romanian Leu", symbol: "lei" },
	RSD: { name: "Serbian Dinar", symbol: "дин" },
	RUB: { name: "Russian Ruble", symbol: "₽" },
	RWF: { name: "Rwandan Franc", symbol: "FRw" },
	SAR: { name: "Saudi Riyal", symbol: "ر.س" },
	SBD: { name: "Solomon Islands Dollar", symbol: "SI$" },
	SCR: { name: "Seychellois Rupee", symbol: "₨" },
	SEK: { name: "Swedish Krona", symbol: "kr" },
	SGD: { name: "Singapore Dollar", symbol: "S$" },
	SHP: { name: "Saint Helena Pound", symbol: "£" },
	SLE: { name: "Sierra Leonean Leone", symbol: "Le" },
	SOS: { name: "Somali Shilling", symbol: "Sh" },
	SRD: { name: "Surinamese Dollar", symbol: "SRD$" },
	STD: { name: "São Tomé and Príncipe Dobra", symbol: "Db" },
	SZL: { name: "Swazi Lilangeni", symbol: "L" },
	THB: { name: "Thai Baht", symbol: "฿" },
	TJS: { name: "Tajikistani Somoni", symbol: "SM" },
	TND: { name: "Tunisian Dinar", symbol: "د.ت" },
	TOP: { name: "Tongan Paʻanga", symbol: "T$" },
	TRY: { name: "Turkish Lira", symbol: "₺" },
	TTD: { name: "Trinidad and Tobago Dollar", symbol: "TT$" },
	TWD: { name: "New Taiwan Dollar", symbol: "NT$" },
	TZS: { name: "Tanzanian Shilling", symbol: "TSh" },
	UAH: { name: "Ukrainian Hryvnia", symbol: "₴" },
	UGX: { name: "Ugandan Shilling", symbol: "USh" },
	USD: { name: "United States Dollar", symbol: "$" },
	UYU: { name: "Uruguayan Peso", symbol: "$U" },
	UZS: { name: "Uzbekistani Som", symbol: "so'm" },
	VND: { name: "Vietnamese Đồng", symbol: "₫" },
	VUV: { name: "Vanuatu Vatu", symbol: "VT" },
	WST: { name: "Samoan Tala", symbol: "T" },
	XAF: { name: "Central African CFA Franc", symbol: "FCFA" },
	XCD: { name: "East Caribbean Dollar", symbol: "EC$" },
	XOF: { name: "West African CFA Franc", symbol: "CFA" },
	XPF: { name: "CFP Franc", symbol: "₣" },
	YER: { name: "Yemeni Rial", symbol: "﷼" },
	ZAR: { name: "South African Rand", symbol: "R" },
	ZMW: { name: "Zambian Kwacha", symbol: "ZK" },
};

export const regenerateTickets = async (eventId) => {
	try {
		const response = await retrieveTicketRegeneration(eventId);
		successToaster("Ticket Regeneration Process started")
		return response;
	} catch (error) {
		console.error("Error in ticket regeneration:", error);
		errorToaster(error)
		throw error;
	}
};
export const dateTimeStampFormat = (date, dateTime) => {
	if (dateTime) {
		return moment(date).format("YYYY-MM-DDTHH:mm:ss")
	} else {
		return moment(date).format("D-M-YYYY")
	}
}

export const calendarReadableData = (date) => {
	return moment(date, "YYYY-MM-DDTHH:mm:ss").toDate()
}

export const roundTo2Decimal = (value) => {
	const num = Number(value);

	if (isNaN(num)) {
		console.error(`roundTo2Decimal: Invalid number input -`, value);
		errorToaster("Invalid number input");
		return null;
	}

	return Number((Math.round((num + Number.EPSILON) * 100) / 100).toFixed(2));
};

export const isOnOrAfterTargetDate = (eventDate, targetDate) => {
	if (!eventDate) return false;
	const createdAt = moment.utc(eventDate);
	const compareTo = moment.utc(targetDate);

	return createdAt.isAfter(compareTo);
}

export const checkFormName = (formName) => {
	if (!formName) return '';
	return formName
		.replace(/[_-]/g, ' ')
		.replace(/\b\w/g, (char) => char.toUpperCase());
};

export const filterForms = (category, formik) => {
	const isWhatsAppForm = checkFormName(category.form_name) === "WhatsApp Number";

	return !(
		isWhatsAppForm &&
		!formik?.values?.whatsapp_enabled &&
		category.er_column_mapping === "whatsapp_number"
	);
};



export const currencyID = {
	1: "INR",
	2: "USD",
	3: "AMD",
	4: "ARS",
	5: "AUD",
	6: "AWG",
	7: "BBD",
	8: "BDT",
	9: "BMD",
	10: "BND",
	11: "BOB",
	12: "BSD",
	13: "BWP",
	14: "BZD",
	15: "CAD",
	16: "CHF",
	17: "CNY",
	18: "COP",
	19: "CRC",
	20: "CUP",
	21: "CZK",
	22: "DKK",
	23: "DOP",
	24: "DZD",
	25: "EGP",
	26: "ETB",
	27: "EUR",
	28: "FJD",
	29: "GBP",
	30: "GIP",
	31: "GHS",
	32: "GMD",
	33: "GTQ",
	34: "GYD",
	35: "HKD",
	36: "HNL",
	37: "HRK",
	38: "HTG",
	39: "HUF",
	40: "IDR",
	41: "ILS",
	42: "AED",
	43: "JMD",
	44: "KES",
	45: "KGS",
	46: "KHR",
	47: "KYD",
	48: "KZT",
	49: "LAK",
	50: "LBP",
	51: "LKR",
	52: "LRD",
	53: "LSL",
	54: "MAD",
	55: "MDL",
	56: "MKD",
	57: "MMK",
	58: "MNT",
	59: "MOP",
	60: "MUR",
	61: "MVR",
	62: "MWK",
	63: "MXN",
	64: "MYR",
	65: "NAD",
	66: "NGN",
	67: "NIO",
	68: "NOK",
	69: "NPR",
	70: "NZD",
	71: "PEN",
	72: "PGK",
	73: "PHP",
	74: "PKR",
	75: "QAR",
	76: "RUB",
	77: "SAR",
	78: "SCR",
	79: "SEK",
	80: "SGD",
	81: "SLL",
	82: "SOS",
	83: "SSP",
	84: "SVC",
	85: "SZL",
	86: "THB",
	87: "TTD",
	88: "TZS",
	89: "ALL",
	90: "UYU",
	91: "UZS",
	92: "YER",
	93: "ZAR",
	97: "BGN",
	100: "BHD",
	101: "OMR",
	95: "KWD",
	94: "JPY",
	96: "BRL",
	98: "PLN",
	99: "RON"
};


export const getTimezoneDisplay = (timezone) => {
	if (!timezone) return "";

	const now = moment().tz(timezone);
	const shortName = now.zoneAbbr(); // e.g., IST, PDT
	const offsetMinutes = now.utcOffset(); // e.g., 330 for +05:30

	const offsetHours = Math.floor(offsetMinutes / 60);
	const offsetMins = Math.abs(offsetMinutes % 60);
	const gmtOffset = `GMT${offsetHours >= 0 ? "+" : "-"}${String(Math.abs(offsetHours)).padStart(2, "0")}:${String(offsetMins).padStart(2, "0")}`;

	return `${shortName} (${gmtOffset})`; // e.g., IST (GMT+05:30)
};


export const EVENT_CONSTANTS = {
	TIMEZONE_INDIA: "asia/calcutta",
	COUNTRY_INDIA: "india",
	CURRENCY_INR: "INR",
	CURRENCY_USD: "USD"

};

export const shouldShowWhatsapp = ({ is_virtual, is_free, country, time_zone, currency_name }) => {
	if (currency_name && currency_name !== EVENT_CONSTANTS.CURRENCY_INR) return false;
	if (is_virtual) {
		return (time_zone?.toLowerCase() === EVENT_CONSTANTS.TIMEZONE_INDIA) || !is_free;
	} else {
		return (country?.toLowerCase() === EVENT_CONSTANTS.COUNTRY_INDIA) || !is_free;
	}
};


// utils/truncateUtils.tsx

// for truncate the case in (...)
export const getTruncatedHtmlElement = (htmlText, maxChars = 100) => {
	if (!htmlText || typeof htmlText !== "string") {
		return {
			isLong: false,
			element: <span />,
		};
	}

	const visibleText = htmlText.replace(/<[^>]*>/g, "");
	const isLong = visibleText.length > maxChars;

	const truncatedText = isLong
		? visibleText.slice(0, maxChars).trim() + "..."
		: visibleText;

	return {
		isLong,
		element: <span>{truncatedText}</span>,
	};
};
export const shouldHideEmailContentOnClone = ({ time_zone, currency_name }) => {
	const normalizedTimeZone = time_zone?.toLowerCase();
	const isIndianTimeZone = normalizedTimeZone === 'asia/kolkata' || normalizedTimeZone === 'asia/calcutta';
	const isIndianCurrency = currency_name === EVENT_CONSTANTS.CURRENCY_INR;

	const isInternational = !isIndianCurrency;
	return isInternational;
};

export const verifyRecaptcha = async (action, token) => {
	if (token) {
		return new Promise(async (resolve, reject) => {
			try {
				const response = await axios.post(`${api.apiUrl}/verify-captcha`, {
					response: token,
					challenge: "checkbox"
				});
				resolve(response);
			} catch (error) {
				toast.error(error, {
					position: "top-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true
				});
			}
		})
	}
}
